module.exports = "/fonts/fa-solid-900.svg?84de948308071ac57e45479e1508e022";